import React from "react";
import { Helmet } from "react-helmet-async";
import useBots from "../../../hooks/useBots";
import QDLoader from "../../../components/QDLoader";
import Setup from "../../../components/bots/Setup";
import useQubot from "../../../hooks/useQubot";
import { Container } from "react-bootstrap";
import Header from "./Header";
import { useTranslation } from "../../../hooks/useLocalization";

const SetupPage = () => {
  const { t } = useTranslation();
  const qubot = useQubot();
  const { isInitialized } = useBots();
  return (
    <React.Fragment>
      <Helmet title={t("Setup")} />
      <Container fluid className="p-0">
        <Header />
        {isInitialized && qubot ? <Setup /> : <QDLoader />}
      </Container>
    </React.Fragment>
  );
};

export default SetupPage;
